export interface Wrestler {
  id: number;
  name: string;
  nickname: string;
  hometown: string;
  weightClass: string;
  style: string;
  signature: string;
  status: string;
  statusColor: string;
  record: string;
  bio: string;
  image: string;
}

export const wrestlers: Wrestler[] = [
  {
    id: 1,
    name: "Eli Emerson",
    nickname: "The Showstopper",
    hometown: "Long Beach, CA",
    weightClass: "Heavyweight",
    style: "Technical / Showman",
    signature: "The Emerson Driver",
    status: "Main Event Contender",
    statusColor: "orange",
    record: "14-3-1",
    bio: "Eli Emerson is the most electrifying performer in PWA history. Known for his flashy ring attire, explosive athleticism, and a mic game that could sell out arenas by itself, The Showstopper has become the face of a generation. Every time his music hits, the crowd goes absolutely electric. He&apos;s a student of the game who combines classic fundamentals with high-risk innovation — a true once-in-a-generation talent.",
    image: "https://framerusercontent.com/images/s15xRGLkH8MaLzKk5GrKEk6hjM.png",
  },
  {
    id: 2,
    name: "El Chivo",
    nickname: "The Goat",
    hometown: "Guadalajara, Mexico",
    weightClass: "Cruiserweight",
    style: "Lucha Libre",
    signature: "The Goat Kick",
    status: "Tag Team Champion",
    statusColor: "green",
    record: "22-7-0",
    bio: "Hailing from the legendary wrestling city of Guadalajara, El Chivo brings the heart and soul of Lucha Libre to every performance. His aerial acrobatics are unmatched anywhere in the United States — a whirlwind of speed, precision, and raw passion. The fans adore him, the locker room respects him, and his opponents fear him. They call him The Goat for a reason.",
    image: "https://framerusercontent.com/images/T1YNzaqHD4hpOhd9PSjLCXdFEXM.png",
  },
  {
    id: 3,
    name: "The Samoan Shooter",
    nickname: "Samoa's Finest",
    hometown: "Apia, Samoa",
    weightClass: "Super Heavyweight",
    style: "Powerhouse / Submission",
    signature: "The Samoan Stretch",
    status: "Former Champion",
    statusColor: "blue",
    record: "19-8-2",
    bio: "A devastating force from the Pacific Islands, The Samoan Shooter is the most physically imposing competitor in the PWA locker room. His background in traditional Samoan wrestling combined with elite submission grappling makes him a nightmare for anyone who steps into his ring. He moves with terrifying purpose and speaks with his actions — bone-crunching, crowd-silencing power moves that remind everyone why this sport can change lives.",
    image: "https://framerusercontent.com/images/7a0o2veawpGPffshoaNr1eI1oA.png",
  },
  {
    id: 4,
    name: "The Candy Girl",
    nickname: "Sweet Destruction",
    hometown: "Los Angeles, CA",
    weightClass: "Women's Division",
    style: "High-Flyer / Striker",
    signature: "The Sugar Rush",
    status: "Women's Division Leader",
    statusColor: "pink",
    record: "11-4-0",
    bio: "Don't let the name fool you. The Candy Girl is one of the most dangerous competitors in PWA regardless of division. Her striking game is as sharp as anyone on the roster, and her aerial style keeps opponents off balance every second of the match. From LA with zero patience for anyone who underestimates her, Sweet Destruction has made it her personal mission to elevate women's wrestling to the main event stage.",
    image: "https://framerusercontent.com/images/0WCLvkNaQ1AfycoZYPGk9qpzKA.png",
  },
  {
    id: 5,
    name: "The Wretched One",
    nickname: "Pure Evil",
    hometown: "Unknown",
    weightClass: "Heavyweight",
    style: "Brawler / Rule Breaker",
    signature: "The Wretched Drop",
    status: "#1 Contender",
    statusColor: "red",
    record: "16-5-3",
    bio: "No one knows where The Wretched One comes from, and frankly — no one wants to ask. A sinister presence who thrives in chaos, The Wretched One has carved a path of destruction through the PWA roster unlike anything seen before. There are no rules in his world, no mercy, no remorse. Just pure, unadulterated evil. The locker room walks on eggshells, the fans are transfixed in morbid fascination, and the champion is on notice.",
    image: "https://framerusercontent.com/images/QIbllmWYmataKTPFcaEJRxlm9hM.png",
  },
];
